import cx from "classnames";
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import * as styles from "./LoginButton.module.css";

type LoginButtonProps = Readonly<{
  onSignIn: () => void;
}>;

export const LoginButton = ({ onSignIn }: LoginButtonProps) => (
  <div className={styles.cMe}>
    <a
      onClick={onSignIn}
      aria-label="Sign in to your account"
      target="_top"
      href="#"
      className={styles.mectrlTrigger}
    >
      <span className={styles.mectrlScreenReaderText}>Sign in to your account</span>
      <div className={styles.mectrlTopHeader} aria-hidden={"true"} role="presentation">
        <div className={cx(styles.mectrlHeaderText, styles.mectrlSignInLink)}>Sign in</div>
        <div
          className={cx(styles.mectrlProfilepic, styles.mectrlSignInCircleGlyph)}
          aria-hidden={"true"}
          role="presentation"
        ></div>
      </div>
    </a>
  </div>
);
